import $ from '@modules/jquery-import';

$.fn.makeSticky = function ( o ) {
    var opt = $.extend( true, {
        container: null,
        offset: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }
    }, o || {} );

    var node = $( this ),
        $body = $( 'body' );

    node = node.children().wrapAll( '<div class="sticky-content" />' );

    if ( opt.container ) {
        var c = $( opt.container );
    }

    var orgPos = {
        offsetHeight: node[0].offsetHeight,
        offsetTop: node.offset().top,
        position: node.css( 'position' ),
        top: node.css( 'top' )
    };

    var cOffsetHeight = (c)
        ? c[0].offsetHeight
        : 0,
        cOffsetTop = (c)
            ? c.offset().top
            : 0,
        cBottom = cOffsetHeight + cOffsetTop;

    $( window ).scroll( function ( e ) {
        var bottom_bound = ((cBottom - opt.offset.bottom) - orgPos.offsetHeight);
        var scroll_top = $( e.target ).scrollTop();

        if ( cBottom !== 0 && bottom_bound <= scroll_top ) {
            node.css( {
                position: 'fixed',
                top: (bottom_bound - scroll_top) + opt.offset.top
            } );
        }
        else if ( orgPos.offsetTop <= (scroll_top + opt.offset.top) ) {
            node.css( {position: 'fixed', top: opt.offset.top} );
        }
        else {
            node.css( {position: orgPos.position, top: orgPos.top} );
        }

    } );
};
